module.exports = __webpack_public_path__ + "img/logo_AAWA-300x150.f6ecbf51.png";